export default {

    //empty-states
    no_coupons: 'Oops! No coupons',
    text_coupon: 'Start by creating a new discount coupon.',
    new_coupon: 'New coupon',

}